/*
 * Rotujące hasła pod opisem w hero.
 *
 * Wszystkie hasła są w HTML-u naraz i leżą jedno NA drugim (CSS: pozycja
 * absolutna w kontenerze o stałej wysokości), więc przy zmianie nic nie skacze,
 * a treść zostaje w źródle strony dla wyszukiwarek.
 *
 * Przy jednym haśle nie uruchamiamy zegara — nie ma czego przełączać.
 */
(function () {
  var CO_ILE_MS = 3000;

  function wepnij(pasek) {
    if (pasek.dataset.haslaGotowe) return;
    var pozycje = pasek.querySelectorAll('.hero-hasla__pozycja');
    if (pozycje.length < 2) return;
    pasek.dataset.haslaGotowe = '1';

    var teraz = 0;
    setInterval(function () {
      // przy schowanej karcie przeglądarka i tak wstrzymuje timery,
      // więc nie ma potrzeby pilnowania widoczności ręcznie
      pozycje[teraz].classList.remove('jest-widoczne');
      teraz = (teraz + 1) % pozycje.length;
      pozycje[teraz].classList.add('jest-widoczne');
    }, CO_ILE_MS);
  }

  function start() {
    document.querySelectorAll('[data-hero-hasla]').forEach(wepnij);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', start);
})();
